import { CommonModule } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { Column } from 'src/app/models/table';
import { TranslationPipe } from 'src/app/pipes/translation/translation-pipe';
import { AppButton } from '../button/app-button';

@Component({
  selector: 'app-table-export-popup',
  imports: [CommonModule, DialogModule, CheckboxModule, FormsModule, AppButton, TranslationPipe],
  templateUrl: './table-export-popup.html',
  styleUrl: './table-export-popup.scss'
})
export class TableExportPopup {
  columns = input<any[]>([]);
  title = input<string>();
  confirmExport = output<string[]>();

  visible = signal(false);
  exportColumns: Column[] = [];

  show() {
    this.exportColumns = this.columns()
      .filter((col) => !!col.header?.trim())
      .map((col) => ({ ...col, checked: true }));
    this.visible.set(true);
  }

  onCancel() {
    this.visible.set(false);
  }

  onConfirm() {
    const checkedIds = this.exportColumns.filter((col) => col.checked).map((col) => col.id);
    this.confirmExport.emit(checkedIds);
    this.visible.set(false);
  }

  buildHeaderParams(col: any) {
    if (!col.headerTranslationParams || col.headerTranslationParams.length === 0) {
      return {};
    }
    return col.headerTranslationParams.reduce((acc: any, val: any, index: any) => {
      acc[index] = val;
      return acc;
    }, {} as any);
  }
}
